<template>
  <profile-card title="Change Password">
    <form @submit.prevent="post">
      <div class="cp-field">
        <h5>
          New Password
          <span style="color:#febc22;font-size:12px;">{{
            passWarningMessage
            }}
          </span>
        </h5>

        <div class="cpp-fiel">
          <i class="fa fa-lock"></i>
          <input
            id="new-password"
            type="password"
            class="form-control"
            name="password"
            placeholder="New Password"
            v-model="password"
          />
          <password
            v-model="password"
            @score="getScore"
            @feedback="showFeedback"
            :strength-meter-only="true"
          />
          <i class="fas fa-eye see-pass" @click="showHidePassword(1)"></i>
        </div>
      </div>
      <div class="cp-field">
        <h5>Repeat Password</h5>
        <div class="cpp-fiel">
          <i class="fa fa-lock"></i>
          <input
            id="password-confirmation"
            type="password"
            class="form-control"
            name="password_confirmation"
            placeholder="Repeat Password"
            v-model="password_confirmation"
          />
          <i class="fas fa-eye see-pass" @click="showHidePassword(2)"></i>
        </div>
      </div>

      <div class="save-stngs pd2">
        <ul>
          <li>
            <button class="ps-btn ps-btn--sm" type="submit">
              Save
            </button>
          </li>
        </ul>
      </div>
      <!--save-stngs end-->
    </form>
  </profile-card>
</template>

<script>
  import Password from "vue-password-strength-meter";

  export default {
    components: {Password},
    data() {
      return {
        errors: null,
        password: null,
        current_password: null,
        password_confirmation: null,
        score: 0,
        passWarningMessage: "",
        isNewPasswordHide: true,
        isPasswordConfirmHide: true,
      };
    },
    methods: {
      showHidePassword: function (passwordType) {
        if (passwordType === 1) {
          if (this.isNewPasswordHide) {
            document.querySelector('#new-password').setAttribute('type', 'text');
            this.isNewPasswordHide = false;
          } else {
            document.querySelector('#new-password').setAttribute('type', 'password');
            this.isNewPasswordHide = true;
          }
        } else if (passwordType === 2) {
          if (this.isPasswordConfirmHide) {
            document.querySelector('#password-confirmation').setAttribute('type', 'text');
            this.isPasswordConfirmHide = false;
          } else {
            document.querySelector('#password-confirmation').setAttribute('type', 'password');
            this.isPasswordConfirmHide = true;
          }
        }
      },
      showFeedback: function ({suggestions, warning}) {
        let message = "";
        if (suggestions[0] != null && suggestions[0] != undefined) {
          message = suggestions[0];
        } else {
          message = "";
        }
        this.passWarningMessage = message;
      },
      getScore: function (score) {
        if (score != null && score !== undefined) this.score = score;
      },
      post: function () {
        if (
          this.password &&
          this.password_confirmation &&
          this.password == this.password_confirmation &&
          parseInt(this.score) < 2
        ) {
          this.$toast.error("Password are to weak!");

          return;
        }
        this.$Progress.start();
        let self = this;
        let data = {
          dob: self.DOB,
          password: self.password,
          password_confirmation: self.password_confirmation
        };
        axios({
          method: "post",
          url:
            "/api/v1/password?_method=patch&api_token=" +
            window.api_token,
          data
        })
          .then(function (res) {
            if (res.data.ok) {
              self.$Progress.finish();
              self.$toast.success(res.data.msg);
            } else {
              self.$Progress.fail();
              self.$toast.error(res.data.msg);
            }
          })
          .catch(function (err) {
            self.$Progress.fail();
            console.log(err);
            if (err.response.status == 422) {
              let errors = err.response.data.data;
              self.errors = errors;
              for (let error in errors) {
                self.$toast.error(errors[error][0]);
              }
            }
          });
      }
    }
  };
</script>
